import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const assignProductUserEntitlementsSlice = getBulkActionSlice(
    'assignProductUserEntitlementsResult',
);

export const selectAssignProductUserEntitlementsShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.assignProductUserEntitlementsResult.shown;

export const selectAssignProductUserEntitlementsBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.assignProductUserEntitlementsResult.uuid;

export const selectAssignProductUserEntitlementsTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.assignProductUserEntitlementsResult.backgroundTask;

export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = assignProductUserEntitlementsSlice.actions;
